import { useState, useEffect, useRef } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { API } from "@/App";
import axios from "axios";

export default function AutocompleteInput({
  label, value, onChange, placeholder = "", endpoint, className = "", testId = ""
}) {
  const [suggestions, setSuggestions] = useState([]);
  const [open, setOpen] = useState(false);
  const [filtered, setFiltered] = useState([]);
  const wrapperRef = useRef(null);

  useEffect(() => {
    axios.get(`${API}/reference/${endpoint}`)
      .then(({ data }) => setSuggestions(data.map(d => d.name)))
      .catch(() => {});
  }, [endpoint]);

  useEffect(() => {
    if (!value) { setFiltered(suggestions.slice(0, 8)); return; }
    const lower = value.toLowerCase();
    setFiltered(suggestions.filter(s => s.toLowerCase().includes(lower)).slice(0, 8));
  }, [value, suggestions]);

  useEffect(() => {
    const handleClick = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  return (
    <div className={`relative ${className}`} ref={wrapperRef}>
      <Label className="text-xs font-semibold uppercase tracking-[0.15em] text-slate-500 mb-1.5 block">{label}</Label>
      <Input
        value={value || ""}
        onChange={(e) => { onChange(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        placeholder={placeholder}
        className="border-slate-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        data-testid={testId}
        autoComplete="off"
      />
      {open && filtered.length > 0 && (
        <div className="absolute z-50 w-full mt-1 bg-white border border-slate-200 rounded-md shadow-lg max-h-48 overflow-y-auto" data-testid={`${testId}-suggestions`}>
          {filtered.map((item, i) => (
            <button
              key={i}
              type="button"
              className="w-full text-left px-3 py-2 text-sm text-slate-700 hover:bg-slate-50 hover:text-slate-900 transition-colors"
              onClick={() => { onChange(item); setOpen(false); }}
              data-testid={`${testId}-option-${i}`}
            >
              {item}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
